export { default as ChildTab } from './ChildTab';
